import React from 'react';
import PropTypes from 'prop-types';
import { getPrCommentDate } from '../../../helpers/DateHelper';
import { Button, Card, CardBody, Row, Container, Table, Col } from 'react-bootstrap';

const PrCommentsTableView = ({ prComments, platform, hideTable, prTitle, handleShowModal }) => {

    const showModal = (codeBlock) => {
        let sameThreadComments = prComments.filter(comment => comment?.codeBlock === codeBlock);
        handleShowModal(sameThreadComments)
    }

    return (
        <Container>
            <Card style={{ marginTop: '10px', height: '30vh' }}>
                <CardBody style={{ paddingLeft: '12px', paddingRight: '12px', paddingTop: '0px' }}>
                    <Row className="align-items-center">
                        <Col className="flex-grow-1">
                            <h6 className="mb-0">PR Title: {prTitle}</h6>
                        </Col>
                        <Col xs="auto">
                            <Button variant="outline" onClick={hideTable} style={{ marginBottom: '10px', width: '40px' }}>
                                {'X'}
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <div style={{ maxHeight: '23vh', overflowY: 'auto' }}>
                            <Table style={{ marginBottom: '0px' }} responsive striped bordered>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Comment</th>
                                        <th>Reviewer</th>
                                        <th>Date</th>
                                        <th>View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {prComments.map((comment, index) => (
                                        <tr key={`${comment.comment}_${platform}_${index}`}>
                                            <td>{index + 1}</td>
                                            <td>{comment.comment}</td>
                                            <td>{comment.commentAuthor}</td>
                                            <td>{getPrCommentDate(comment, platform)}</td>
                                            <td className="text-center">
                                                {comment.codeBlock && <Button
                                                    variant="link"
                                                    onClick={() => showModal(comment.codeBlock)}
                                                    title="View Details"
                                                >
                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                </Button>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </Container>
    );
}

PrCommentsTableView.propTypes = {
    prComments: PropTypes.array.isRequired,
    platform: PropTypes.string.isRequired,
    hideTable: PropTypes.func.isRequired,
    prTitle: PropTypes.string.isRequired,
    handleShowModal: PropTypes.func.isRequired
}

export default PrCommentsTableView;
